import "dayjs/locale/en-gb";
import "@/Lib/FontAwsome";
import axios from "axios";
import dayjs from "dayjs";

import "tinymce/tinymce";
import 'tinymce/icons/default';
import "tinymce/themes/silver";
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

dayjs
    .extend(require('dayjs/plugin/isoWeek'))
    .extend(require('dayjs/plugin/calendar'))
    .extend(require('dayjs/plugin/weekday'))
    .extend(require('dayjs/plugin/isToday'))
    .extend(require('dayjs/plugin/isSameOrAfter'))
    .extend(require('dayjs/plugin/isBetween'))
    .extend(require('dayjs/plugin/customParseFormat'))
    .locale('en-gb');



/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
